import { z } from 'zod';

import { PrimaryKeySchema, commaDelimitedList } from './utils';

/**
 * Schema for agent execution code sandbox states which store versioned sandbox data
 */
export const AgentExecutionCodeSandboxStateSchema = z.object({
  agentExecutionCodeSandboxStateId: PrimaryKeySchema,
  agentExecutionId: PrimaryKeySchema,
  state: z.record(z.any()),
  version: z.number(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type AgentExecutionCodeSandboxState = z.infer<
  typeof AgentExecutionCodeSandboxStateSchema
>;

export const AgentExecutionCodeSandboxStatesSchema = z.array(
  AgentExecutionCodeSandboxStateSchema,
);

export type AgentExecutionCodeSandboxStates = z.infer<
  typeof AgentExecutionCodeSandboxStatesSchema
>;

export const CreateAgentExecutionCodeSandboxStateSchema =
  AgentExecutionCodeSandboxStateSchema.pick({
    agentExecutionId: true,
    state: true,
    version: true,
  }).partial({
    version: true, // version is optional, will be auto-incremented if not provided
  });

export type CreateAgentExecutionCodeSandboxState = z.infer<
  typeof CreateAgentExecutionCodeSandboxStateSchema
>;

export const AgentExecutionCodeSandboxStatesQueryOptionsSchema = z.object({
  agentExecutionCodeSandboxStateIds: commaDelimitedList(
    z.string().array(),
  ).optional(),
  agentExecutionIds: commaDelimitedList(z.string().array()).optional(),
  versions: commaDelimitedList(z.number().array()).optional(),
  latest: z.boolean().optional(), // when combined with agentExecutionId, gets the latest version
});

export type AgentExecutionCodeSandboxStatesQueryOptions = z.infer<
  typeof AgentExecutionCodeSandboxStatesQueryOptionsSchema
>;
